let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("39P7F")).then(() => parcelRequire('f8bcI'));